import type {UrlStateManagerService} from 'shared/state-manager';
import type {TabId} from './types';
import type {Observable} from 'rxjs';
import {firstValueFrom} from 'rxjs';

export class TabPagesUrlManagementService {
    public static serviceName = 'tabPagesUrlManagementService';

    /*@ngInject*/
    constructor(private urlStateManagerService: UrlStateManagerService<TabbedSubpagesUrlState>) {
    }

    public async getCurrentUrlState(): Promise<TabbedSubpagesUrlState> {
        const urlState$ = this.urlStateManagerService.getState$();
        return firstValueFrom(urlState$);
    }

    public setActiveTab(value: TabId): void {
        this.urlStateManagerService.requestChangeStateParameter('activeTab', value, true);
    }

    public getUrlState$(): Observable<TabbedSubpagesUrlState> {
        return this.urlStateManagerService.getState$();
    }
}

class TabbedSubpagesUrlState {
    activeTab?: TabId;
}